import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export type Time = string | number | Date | dayjs.Dayjs;

// 本地时间
export const formatLocalTime = (time: Time, format = 'YYYY-MM-DD HH:mm:ss') =>
  `${dayjs.utc(time).local().format(format)}`;

export const formatTimeDiff = (ms: number) => {
  if (!ms) return '--';

  const totalSeconds = Math.floor(ms / 1000);
  const days = Math.floor(totalSeconds / (3600 * 24));
  const hours = Math.floor((totalSeconds % (3600 * 24)) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  if (days > 0) {
    return `${days}D ${hours}H ${minutes}M ${seconds}S`;
  } else if (hours > 0) {
    return `${hours}H ${minutes}M ${seconds}S`;
  } else if (minutes > 0) {
    return `${minutes}M ${seconds}S`;
  } else {
    return `${seconds}S`;
  }
};
